import { render, staticRenderFns } from "./ChatTabs.vue?vue&type=template&id=3c3f692b&"
import script from "./ChatTabs.vue?vue&type=script&lang=ts&"
export * from "./ChatTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports